import { render, staticRenderFns } from "./CourseStep.vue?vue&type=template&id=23ad8dc4&"
import script from "./CourseStep.vue?vue&type=script&lang=js&"
export * from "./CourseStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports